import React, { Component } from 'react'
import { API_BASE, GOOGLE_OAUTH2_PATH } from 'consts'
import { Notice, Button } from 'components'
import { AnalyticsUtils } from 'utils'

export default class AccessRevokedError extends React.Component {
  static propTypes = {
    user: React.PropTypes.object.isRequired
  }

  componentWillMount() {
    AnalyticsUtils.searchConsoleErrorViewed(this.props.user.email, "access_revoked")
  }

  handleReconnectToSearchConsole() {
    AnalyticsUtils.startedGoogleAccountReconnection(this.props.user.email)
    window.location = `${API_BASE}${GOOGLE_OAUTH2_PATH}`
  }

  body() {
    return (
      <div>
        <p>Access to Google Search Console has been revoked.</p>
        <p className="small-spacing--top">Do you want to continue tracking your SEO data through Plug in SEO?</p>
        <div className="medium-spacing--top">
          <Button
            label="Yes, Reconnect"
            buttonType="primary"
            onTouchTap={::this.handleReconnectToSearchConsole}
          />
          <div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    return <Notice error={true} header="Search Console Access Revoked" note={this.body()} />
  }
}



// WEBPACK FOOTER //
// ./app/components/search_console/partials/AccessRevokedError.js